// PortalSwitcher.tsx — مُبدِّل «الإدارة ⇄ بوابتي كمالك» (خطة OwnerPortalShell_Plan_2026-07-12.md
// §B4). يظهر فقط لحساب موظّف/مدير مرتبط أيضًا بسجلّ مالك (isHorseOwnerAccount) وله صفحة
// إدارية واحدة على الأقل — المالك الصِرف لا يملك أي صفحة إدارية فلا يراه أبدًا، والموظّف غير
// المرتبط بمالك لا يحقّق isHorseOwnerAccount فلا يراه أيضًا.
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { compactKey } from '../../lib/accessControl';
import { readJsonStorage, readStorage } from '../../lib/storage';
import type { Permission } from '../../lib/accessControl';
import { isHorseOwnerAccount } from '../menuLogic';
import { ALL_OWNER_PATHS, isOwnerPath } from './ownerNav';
import { cn } from '../../lib/utils';

export const LAST_ADMIN_PATH_KEY = 'smart_last_admin_path';

const OWNER_PATH_KEYS = new Set(ALL_OWNER_PATHS.map((path) => compactKey(path)));

export function hasAdminPage(permissions: Permission[]): boolean {
	return permissions.some((p) => {
		if (Number(p?.can_access) !== 1) return false;
		const key = compactKey(p.page_name || p.permission_key || '');
		return key && !OWNER_PATH_KEYS.has(key);
	});
}

export function PortalSwitcher() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	if (!isHorseOwnerAccount()) return null;
	const permissions = readJsonStorage<Permission[]>('permissions', []);
	if (!hasAdminPage(permissions)) return null;

	const onOwnerSide = isOwnerPath(location.pathname);

	const goAdmin = () => {
		if (onOwnerSide) return;
		navigate(readStorage(LAST_ADMIN_PATH_KEY) || '/home');
	};
	const goOwner = () => navigate('/owner-home');

	return (
		<div className="flex rounded-full bg-muted p-0.5 text-xs">
			<button
				onClick={goAdmin}
				className={cn('rounded-full px-3 py-1 font-bold transition-colors', !onOwnerSide ? 'bg-primary text-primary-foreground' : 'text-muted-foreground')}
			>
				{t('ownerShell.adminSide', 'الإدارة')}
			</button>
			<button
				onClick={goOwner}
				className={cn('rounded-full px-3 py-1 font-bold transition-colors', onOwnerSide ? 'bg-primary text-primary-foreground' : 'text-muted-foreground')}
			>
				{t('ownerShell.ownerSide', 'بوابتي كمالك')}
			</button>
		</div>
	);
}
